import { render } from "./Sign.vue?vue&type=template&id=3fe8e8ca&scoped=true&ts=true"
import script from "./Sign.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sign.vue?vue&type=script&setup=true&lang=ts"

import "./Sign.vue?vue&type=style&index=0&id=3fe8e8ca&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe8e8ca"],['__file',"src/views/me/Sign.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fe8e8ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fe8e8ca', __exports__)) {
    console.log('reload')
    api.reload('3fe8e8ca', __exports__)
  }
  
  module.hot.accept("./Sign.vue?vue&type=template&id=3fe8e8ca&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3fe8e8ca', render)
  })

}


export default __exports__